import { useMemo } from 'react';

// Adatta il rendering 3D al device: mobile = texture 1K, meno geometria, niente postprocessing.
export default function useDeviceQuality() {
  return useMemo(() => {
    const ua = navigator.userAgent || '';
    const isMobile = /iPhone|iPad|iPod|Android|Mobile|webOS|BlackBerry/i.test(ua) || window.innerWidth < 768;
    const cores = navigator.hardwareConcurrency || 4;
    const mem = navigator.deviceMemory || 4;
    const low = isMobile || cores <= 4 || mem <= 3;
    return {
      isMobile,
      lite: isMobile,
      tier: low ? 'low' : 'high',
      dpr: isMobile ? [1, 1.25] : low ? [1, 1.4] : [1, 1.8],
      starsCount: isMobile ? 900 : low ? 1800 : 4500,
      segments: isMobile ? 56 : 96,
      tiles: isMobile ? [4, 5] : [8, 6],
      shadows: !low,
      bloom: !low,
    };
  }, []);
}
